import React from 'react';
import { currentVersion } from 'config';
import { parseBuildDatetime } from 'utils/dateTimeUtils';

function BuildDate() {
  return <span>Build date UTC: {parseBuildDatetime(currentVersion)}</span>;
}

export default BuildDate;
